// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Table,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Form,
//   Modal,
//   Label,
//   Input,
// } from "reactstrap";
// import { useTable, useGlobalFilter, usePagination } from "react-table";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import Select from "react-select";
// // css
// import "../../../assets/css/Settings/Setting.css";
// import "../../../assets/css/Marketing/Marketing.css";

// // commom
// import Pagination from "components/Common/Pagination";

// // editor
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import configure from "configure";
// import { set } from "lodash";
// import {
//   colourStyles,
//   locationOptions,
//   status_options,
//   TenderStatus,
// } from "utils/common-options";
// import axios from "axios";
// import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData";
// import Loader from "pages/Separate/Loader";
// import Swal from "sweetalert2";
// import { TenderColumns } from "utils/columns/Marketing/TenderCols";
// import { useSelector } from "react-redux";
// import secureLocalStorage from "react-secure-storage";
// import { Draggable } from "devextreme-react";
// import { ResizableBox } from "react-resizable";
// import moment from "moment";

// function TableContainer({
//   columns,
//   data,
//   setData,
//   setLoading,
//   refreshData,
//   sourceId,
// }) {
//   const [fixedContent, setFixedContent] = useState(false);
//   const [addTenderModal, setAddTenderModal] = useState(false);
//   const [originalData, setOriginalData] = useState([]); // ✅ store original untouched data

//   const navigate = useNavigate();

//   document.addEventListener("scroll", () => {
//     if (window.scrollY > 160) {
//       setFixedContent(true);
//     } else {
//       setFixedContent(false);
//     }
//   });

//   useEffect(() => {
//     const updateWidth = () => {
//       const viewportWidth = window.innerWidth;
//       setBoxWidth(viewportWidth * 0.7);
//     };
//     updateWidth();
//   }, []);

//   useEffect(() => {
//     setOriginalData(data);
//   }, []);

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     state,
//     previousPage,
//     nextPage,
//     canPreviousPage,
//     canNextPage,
//     gotoPage,
//     setPageSize,
//     pageOptions,
//     setGlobalFilter,
//     prepareRow,
//   } = useTable(
//     {
//       columns,
//       data,
//     },
//     useGlobalFilter,
//     usePagination
//   );

//   const handleFilter = (e) => {
//     e.preventDefault();

//     console.log("▶ FILTER CLICKED");

//     // 1) no filters selected at all
//     if (!fromDateFilter && !toDateFilter && !status) {
//       Swal.fire({
//         icon: "warning",
//         title: "No Filters Applied",
//         text: "Please select at least one filter.",
//       });
//       return;
//     }

//     // 2) partially entered date
//     if (
//       (fromDateFilter && !toDateFilter) ||
//       (!fromDateFilter && toDateFilter)
//     ) {
//       Swal.fire({
//         icon: "warning",
//         title: "Incomplete Date Filter",
//         text: "Please select both Start Date and End Date to filter by date.",
//       });
//       return;
//     }

//     console.log("fromDateFilter: ", fromDateFilter);
//     console.log("toDateFilter: ", toDateFilter);

//     // start filter on original data always
//     let filteredData = [...originalData];

//     // 3) full date filter selected
//     if (fromDateFilter && toDateFilter) {
//       if (moment(fromDateFilter).isAfter(moment(toDateFilter))) {
//         Swal.fire({
//           icon: "warning",
//           title: "Invalid Date Range",
//           text: "End Date must be after Start Date.",
//         });
//         return;
//       }

//       filteredData = filteredData.filter((item) => {
//         const submissionDate = moment(item.tender_submittion_date).startOf(
//           "day"
//         );
//         const from = moment(fromDateFilter).startOf("day");
//         const to = moment(toDateFilter).endOf("day");

//         return (
//           submissionDate.isSameOrAfter(from) &&
//           submissionDate.isSameOrBefore(to)
//         );
//       });
//     }

//     // 4) status filter (optional)
//     if (status) {
//       filteredData = filteredData.filter(
//         (item) => item.status?.toString() === status.value?.toString()
//       );
//     }

//     console.log("Filtered Final:", filteredData.length);
//     setData(filteredData);
//   };

//   const handleClear = () => {
//     setFromDateFilter("");
//     setToDateFilter("");
//     setStatus(null);
//     setData(originalData);
//     refreshData();
//   };

//   const { pageIndex, pageSize, globalFilter } = state;
//   const [filterPopup, setFilterPopup] = useState(false);
//   const [boxWidth, setBoxWidth] = useState(300);
//   const [fromDateFilter, setFromDateFilter] = useState("");
//   const [toDateFilter, setToDateFilter] = useState("");
//   const [status, setStatus] = useState(null);

//   // Render the UI for your table
//   return (
//     <div>
//       <Row className="mb-2">
//         <Col>
//           <select
//             className="border-radius form-select"
//             style={{ width: "100px" }}
//             value={pageSize}
//             onChange={(e) => setPageSize(e.target.value)}
//           >
//             {[10, 20, 30, 40, 50].map((pageSize) => (
//               <option key={pageSize} value={pageSize}>
//                 Show {pageSize}
//               </option>
//             ))}
//           </select>
//         </Col>
//         {/* <Col md={10} className="d-flex justify-content-end">
//           <div className="me-4">
//             <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
//               <button
//                 // onClick={() => setFilterPopup(!filterPopup)}
//                 className="btn btn-outline-secondary"
//               >
//                 <i className="fas fa-filter"></i>
//               </button>
//               <div className="position-relative">
//                 <label htmlFor="search-bar-0" className="search-label">
//                   <span id="search-bar-0-label" className="sr-only">
//                     Search this table
//                   </span>
//                   <input
//                     onChange={(e) => setGlobalFilter(e.target.value)}
//                     id="search-bar-0"
//                     type="text"
//                     className="border-radius form-control rounded h-100"
//                     placeholder={` Search...`}
//                     value={globalFilter || ""}
//                   />
//                 </label>
//                 <i className="bx bx-search-alt search-icon"></i>
//               </div>
//             </div>
//           </div>
//           <div>
//             <Link
//               to={`${configure.appUrl}marketing/add-tender/${sourceId}`}
//               className="border-radius btn btn-purple me-2"
//             >
//               <i className="fas fa-plus me-2 icon-size"></i>Tender
//             </Link>
//           </div>
//         </Col> */}
//         <Col
//           md={10}
//           className="d-flex align-items-center justify-content-end gap-2"
//         >
//           {/* FILTER */}
//           <button
//             onClick={() => setFilterPopup(!filterPopup)}
//             className="btn btn-outline-secondary"
//           >
//             <i className="fas fa-filter"></i>
//           </button>

//           {/* SEARCH */}
//           <div className="search-box position-relative mt-2 ">
//             <label
//               htmlFor="search-bar-0"
//               className="search-label d-flex align-items-center"
//             >
//               <input
//                 onChange={(e) => setGlobalFilter(e.target.value)}
//                 id="search-bar-0"
//                 type="text"
//                 className="border-radius form-control rounded h-100"
//                 placeholder=" Search..."
//                 value={globalFilter || ""}
//               />
//               <i className="bx bx-search-alt search-icon"></i>
//             </label>
//           </div>

//           {/* ADD TENDER */}
//           <Link
//             to={`${configure.appUrl}marketing/add-tender/${sourceId}`}
//             className="border-radius btn btn-purple"
//           >
//             <i className="fas fa-plus me-2 icon-size"></i>Tender
//           </Link>
//         </Col>
//       </Row>

//       <div className="position-relative">
//         <Table className="table table-bordered mt-3" {...getTableProps()}>
//           <thead
//             className={`${
//               fixedContent ? "fixed-setting-header" : ""
//             } fix-Tender-header`}
//           >
//             {headerGroups.map((headerGroup, i) => (
//               <tr key={i} {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup.headers.map((column, index) => (
//                   <th
//                     key={index}
//                     className={`t-col-${index + 1} ${column.className}`}
//                     {...column.getHeaderProps()}
//                   >
//                     {column.render("Header")}
//                     {column.isInfoIcon ? (
//                       <i
//                         title="info"
//                         className="bx bx-info-circle ms-1 info-icon"
//                       ></i>
//                     ) : null}
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>

//           <tbody className="fix-Tender-header" {...getTableBodyProps()}>
//             {page.map((row, i) => {
//               prepareRow(row);
//               return (
//                 <tr className="row-hover" {...row.getRowProps()} key={i}>
//                   {row.cells.map((cell, index) => {
//                     return (
//                       <td
//                         key={index}
//                         className={`t-col-${index + 1} ${
//                           cell.column.className
//                         }`}
//                         {...cell.getCellProps()}
//                       >
//                         {cell.render("Cell")}
//                       </td>
//                     );
//                   })}
//                 </tr>
//               );
//             })}
//           </tbody>
//         </Table>
//       </div>

//       {/* Pagination */}
//       <Row className="justify-content-md-end justify-content-center align-items-center">
//         <Pagination
//           gotoPage={gotoPage}
//           previousPage={previousPage}
//           canPreviousPage={canPreviousPage}
//           nextPage={nextPage}
//           canNextPage={canNextPage}
//           pageIndex={pageIndex}
//           pageOptions={pageOptions}
//         />
//       </Row>
//       {filterPopup ? (
//         <Draggable>
//           <ResizableBox
//             width={boxWidth}
//             style={{
//               position: "fixed",
//               top: "30%",
//               right: "3%",
//               zIndex: "1055",
//               backgroundColor: "#fff",
//             }}
//           >
//             <Form
//               onSubmit={handleFilter}
//               className="row d-flex justify-content-center align-items-center"
//             >
//               <div className="col-md-12 d-flex ">
//                 <div className="col-md-2 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">From Date</Label>
//                   <Input
//                     type="date"
//                     // required={toDateFilter ? true : false}
//                     value={fromDateFilter}
//                     onChange={(e) => {
//                       console.log("FromDate: ", fromDateFilter);
//                       setFromDateFilter(e.target.value);
//                     }}
//                   />
//                 </div>
//                 <div className="col-md-2 ps-2">
//                   <Label htmlFor="formrow-firstname-Input">To Date</Label>
//                   <Input
//                     type="date"
//                     value={toDateFilter}
//                     onChange={(e) => {
//                       console.log("FromDate: ", fromDateFilter);
//                       setToDateFilter(e.target.value);
//                     }}
//                   />
//                 </div>
//                 <div className="col-md-3 ps-2">
//                   <label htmlFor="">Status</label>
//                   <Select
//                     placeholder="Status"
//                     className="basic-multi-select"
//                     classNamePrefix="select"
//                     styles={colourStyles}
//                     options={TenderStatus}
//                     value={status}
//                     onChange={(e) => setStatus(e)}
//                   />
//                 </div>

//                 <div className="col-md-5 d-flex justify-content-end align-items-center gap-2">
//                   <a
//                     className="btn  btn-danger"
//                     style={{
//                       fontSize: "14px",
//                       backgroundColor: "#fed36d",
//                       borderColor: "#fed36d",
//                       color: "black",
//                     }}
//                     onClick={() => handleClear()}
//                   >
//                     Clear Filters
//                   </a>
//                   <button className="btn  btn-save btn-label me-1">
//                     <i className="fas fa-filter search-icon label-icon"></i>{" "}
//                     Filter
//                   </button>
//                   <a
//                     className="btn btn-red btn-label me-1"
//                     onClick={() => {
//                       setFilterPopup(false);
//                     }}
//                   >
//                     <i className="dripicons-cross label-icon"></i> Close
//                   </a>
//                 </div>
//               </div>
//             </Form>
//           </ResizableBox>
//         </Draggable>
//       ) : null}
//     </div>
//   );
// }

// const Tender = ({ verticalActiveTab }) => {
//   const [isLoading, setLoading] = useState(false);
//   const [tenderData, setTenderData] = useState([]);

//   const fetchData = async () => {
//     const user_id = localStorage.getItem("auth_id");
//     const response = await fetchNodeData(
//       setLoading,
//       `tender/getTenders/${user_id}/${verticalActiveTab}`,
//       secureLocalStorage.getItem("auth_token")
//     );
//     if (response?.status === 200) {
//       const dataWithMappedField = response.data.map((item) => ({
//         ...item,
//         aboutTender: item.description,
//       }));
//       setTenderData(dataWithMappedField);
//     } else {
//       setTenderData([]);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [verticalActiveTab]);

//   const onDelete = (id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Do you really want to delete this Tender!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, do it!",
//       cancelButtonText: "No, cancel!",
//     }).then(async (willDelete) => {
//       if (willDelete) {
//         setLoading(true);
//         const user_id = localStorage.getItem("auth_id");
//         try {
//           const response = await axios.delete(
//             `${configure.nodeApi}/tender/${id}/${user_id}`
//           );
//           if (response.data.status === 200) {
//             Swal.fire({
//               icon: "success",
//               title: "Success",
//               text: "Tender Deleted successfully",
//             });
//             fetchData();
//           } else {
//             Swal.fire({
//               icon: "error",
//               title: "error",
//               text: response.data.message,
//             });
//           }
//         } catch (error) {
//           Swal.fire({
//             icon: "error",
//             title: "error",
//             text: error.message,
//           });
//         }
//       }
//     });
//   };

//   const columns = useMemo(() => TenderColumns(onDelete), []);

//   return (
//     <>
//       <div>
//         {isLoading && <Loader />}
//         <Row className="ms-0 pe-0">
//           <Col lg={12} className="p-0">
//             <Card>
//               <CardBody>
//                 <TableContainer
//                   columns={columns}
//                   refreshData={fetchData}
//                   data={tenderData}
//                   setData={setTenderData}
//                   status_options={TenderStatus}
//                   setLoading={setLoading}
//                   sourceId={verticalActiveTab}
//                 />
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </div>
//     </>
//   );
// };

// export default Tender;

import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Modal,
  Label,
  Input,
} from "reactstrap";
import { useTable, useGlobalFilter, usePagination } from "react-table";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Select from "react-select";
// css
import "../../../assets/css/Settings/Setting.css";
import "../../../assets/css/Marketing/Marketing.css";

// commom
import Pagination from "components/Common/Pagination";

// editor
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import configure from "configure";
import { set } from "lodash";
import {
  colourStyles,
  locationOptions,
  status_options,
  TenderStatus,
} from "utils/common-options";
import axios from "axios";
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData";
import Loader from "pages/Separate/Loader";
import Swal from "sweetalert2";
import { TenderColumns } from "utils/columns/Marketing/TenderCols";
import { useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import { Draggable } from "devextreme-react";
import { ResizableBox } from "react-resizable";
import moment from "moment";

function TableContainer({
  columns,
  data,
  setData,
  setLoading,
  refreshData,
  sourceId,
  originalData2,
}) {
  const [fixedContent, setFixedContent] = useState(false);
  const [addTenderModal, setAddTenderModal] = useState(false);
  const [originalData, setOriginalData] = useState(data);

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });

  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.7);
    };
    updateWidth();
  }, []);

  useEffect(() => {
    setOriginalData(data);
    console.log("originalData: ", originalData);
  }, [data]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  );

  // const handleFilter = (e) => {
  //   e.preventDefault();

  //   console.log("▶ FILTER CLICKED");

  //   // Log initial values
  //   console.log("RAW fromDateFilter:", fromDateFilter);
  //   console.log("RAW toDateFilter:", toDateFilter);
  //   console.log("RAW status:", status);
  //   console.log("Original Data Count:", originalData?.length);

  //   // 1) no filters selected at all
  //   if (!fromDateFilter && !toDateFilter && !status) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "No Filters Applied",
  //       text: "Please select at least one filter.",
  //     });
  //     return;
  //   }

  //   // 2) partially entered date
  //   if (
  //     (fromDateFilter && !toDateFilter) ||
  //     (!fromDateFilter && toDateFilter)
  //   ) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Incomplete Date Filter",
  //       text: "Please select both Start Date and End Date to filter by date.",
  //     });
  //     return;
  //   }

  //   console.log("fromDateFilter: ", fromDateFilter);
  //   console.log("toDateFilter: ", toDateFilter);

  //   let filteredData = [...originalData];

  //   // 3) full date filter selected
  //   if (fromDateFilter && toDateFilter) {
  //     console.log(
  //       "Parsed FROM:",
  //       fromDateFilter + " 00:00:00",
  //       "Parsed TO:",
  //       toDateFilter + " 23:59:59"
  //     );

  //     const from = moment(fromDateFilter + " 00:00:00", "YYYY-MM-DD HH:mm:ss");
  //     const to = moment(toDateFilter + " 23:59:59", "YYYY-MM-DD HH:mm:ss");

  //     // Log moment validity
  //     console.log("Moment FROM is valid:", from.isValid());
  //     console.log("Moment TO is valid:", to.isValid());

  //     if (moment(fromDateFilter).isAfter(moment(toDateFilter))) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Invalid Date Range",
  //         text: "End Date must be after Start Date.",
  //       });
  //       return;
  //     }

  //     filteredData = filteredData.filter((item, index) => {
  //       const submissionDate = moment(
  //         item.tender_submittion_date,
  //         "YYYY-MM-DD HH:mm:ss"
  //       );

  //       // log each item
  //       console.log(
  //         `Row ${index} | submissionDate: ${
  //           item.tender_submittion_date
  //         } | Valid: ${submissionDate.isValid()}`
  //       );

  //       const match =
  //         submissionDate.isSameOrAfter(from) &&
  //         submissionDate.isSameOrBefore(to);

  //       if (match) {
  //         console.log(`✔ MATCH (Row ${index})`);
  //       } else {
  //         console.log(`✘ NOT MATCH (Row ${index})`);
  //       }

  //       return match;
  //     });

  //     console.log("After Date Filter Count:", filteredData.length);
  //   }

  //   // 4) status filter (optional)
  //   if (status) {
  //     console.log("Applying Status Filter:", status.value);

  //     filteredData = filteredData.filter((item, index) => {
  //       const match = item.status?.toString() === status.value?.toString();

  //       console.log(
  //         `Row ${index} | item.status: ${item.status} | match: ${match}`
  //       );

  //       return match;
  //     });

  //     console.log("After Status Filter Count:", filteredData.length);
  //   }

  //   console.log("Filtered Final:", filteredData.length);
  //   setData(filteredData);
  // };

  const handleFilter = (e) => {
    e.preventDefault();
    console.log("FILTER CLICKED");

    // 1) No filters selected
    if (!fromDateFilter && !toDateFilter && !status) {
      Swal.fire({
        icon: "warning",
        title: "No Filters Applied",
        text: "Please select at least one filter.",
      });
      return;
    }

    // 2) Incomplete date range
    if (
      (fromDateFilter && !toDateFilter) ||
      (!fromDateFilter && toDateFilter)
    ) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Date Filter",
        text: "Please select both Start Date and End Date.",
      });
      return;
    }

    // Start from original untouched data
    let filteredData = [...originalData2];

    // 3) Date Range Filter (THIS IS THE CORRECT WAY)
    if (fromDateFilter && toDateFilter) {
      const fromDate = moment(fromDateFilter).startOf("day"); // 00:00:00
      const toDate = moment(toDateFilter).endOf("day"); // 23:59:59

      if (fromDate.isAfter(toDate)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Date Range",
          text: "End Date must be same or after Start Date.",
        });
        return;
      }

      filteredData = filteredData.filter((item) => {
        // This handles ISO strings like "2025-11-10T00:00:00.000Z" perfectly
        const submissionDate = moment(item.tender_submittion_date);

        // Optional: debug invalid dates
        if (!submissionDate.isValid()) {
          console.warn(
            "Invalid date in tender:",
            item.id,
            item.tender_submittion_date
          );
          return false;
        }

        return (
          submissionDate.isSameOrAfter(fromDate) &&
          submissionDate.isSameOrBefore(toDate)
        );
      });
    }

    // 4) Status Filter (safe comparison)
    if (status) {
      filteredData = filteredData.filter((item) => {
        const itemStatus = item.status?.toString().trim();
        const filterStatus = status.value?.toString().trim();
        return itemStatus === filterStatus;
      });
    }

    console.log("Filtered Final:", filteredData.length);
    setData(filteredData);
  };

  const handleClear = () => {
    setFromDateFilter("");
    setToDateFilter("");
    setStatus(null);
    setData(originalData);
    refreshData();
  };

  const { pageIndex, pageSize, globalFilter } = state;
  const [filterPopup, setFilterPopup] = useState(false);
  const [boxWidth, setBoxWidth] = useState(300);
  const [fromDateFilter, setFromDateFilter] = useState("");
  const [toDateFilter, setToDateFilter] = useState("");
  const [status, setStatus] = useState(null);

  // Render the UI for your table
  return (
    <div>
      <Row className="mb-2">
        <Col>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        {/* <Col md={10} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <button
                // onClick={() => setFilterPopup(!filterPopup)}
                className="btn btn-outline-secondary"
              >
                <i className="fas fa-filter"></i>
              </button>
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <Link
              to={`${configure.appUrl}marketing/add-tender/${sourceId}`}
              className="border-radius btn btn-purple me-2"
            >
              <i className="fas fa-plus me-2 icon-size"></i>Tender
            </Link>
          </div>
        </Col> */}
        <Col
          md={10}
          className="d-flex align-items-center justify-content-end gap-2"
        >
          {/* FILTER */}
          <button
            onClick={() => setFilterPopup(!filterPopup)}
            className="btn btn-outline-secondary"
          >
            <i className="fas fa-filter"></i>
          </button>

          {/* SEARCH */}
          <div className="search-box position-relative mt-2 ">
            <label
              htmlFor="search-bar-0"
              className="search-label d-flex align-items-center"
            >
              <input
                onChange={(e) => setGlobalFilter(e.target.value)}
                id="search-bar-0"
                type="text"
                className="border-radius form-control rounded h-100"
                placeholder=" Search..."
                value={globalFilter || ""}
              />
              <i className="bx bx-search-alt search-icon"></i>
            </label>
          </div>

          {/* ADD TENDER */}
          <Link
            to={`${configure.appUrl}marketing/add-tender/${sourceId}`}
            className="border-radius btn btn-purple"
          >
            <i className="fas fa-plus me-2 icon-size"></i>Tender
          </Link>
        </Col>
      </Row>

      <div className="position-relative">
        <Table className="table table-bordered mt-3" {...getTableProps()}>
          <thead
            className={`${
              fixedContent ? "fixed-setting-header" : ""
            } fix-Tender-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-Tender-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${
                          cell.column.className
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
      {filterPopup ? (
        <Draggable>
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "30%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <Form
              onSubmit={handleFilter}
              className="row d-flex justify-content-center align-items-center"
            >
              <div className="col-md-12 d-flex ">
                <div className="col-md-2 ps-2">
                  <Label htmlFor="formrow-firstname-Input">From Date</Label>
                  <Input
                    type="date"
                    // required={toDateFilter ? true : false}
                    value={fromDateFilter}
                    onChange={(e) => {
                      console.log("FromDate: ", fromDateFilter);
                      setFromDateFilter(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-2 ps-2">
                  <Label htmlFor="formrow-firstname-Input">To Date</Label>
                  <Input
                    type="date"
                    value={toDateFilter}
                    onChange={(e) => {
                      console.log("FromDate: ", fromDateFilter);
                      setToDateFilter(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-3 ps-2">
                  <label htmlFor="">Status</label>
                  <Select
                    placeholder="Status"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={TenderStatus}
                    value={status}
                    onChange={(e) => setStatus(e)}
                  />
                </div>

                <div className="col-md-5 d-flex justify-content-end align-items-center gap-2">
                  <a
                    className="btn  btn-danger"
                    style={{
                      fontSize: "14px",
                      backgroundColor: "#fed36d",
                      borderColor: "#fed36d",
                      color: "black",
                    }}
                    onClick={() => handleClear()}
                  >
                    Clear Filters
                  </a>
                  <button className="btn  btn-save btn-label me-1">
                    <i className="fas fa-filter search-icon label-icon"></i>{" "}
                    Filter
                  </button>
                  <a
                    className="btn btn-red btn-label me-1"
                    onClick={() => {
                      setFilterPopup(false);
                    }}
                  >
                    <i className="dripicons-cross label-icon"></i> Close
                  </a>
                </div>
              </div>
            </Form>
          </ResizableBox>
        </Draggable>
      ) : null}
    </div>
  );
}

const Tender = ({ verticalActiveTab }) => {
  const [isLoading, setLoading] = useState(false);
  const [tenderData, setTenderData] = useState([]);
  const [originalData2, setOriginalData2] = useState([]);

  const fetchData = async () => {
    const user_id = localStorage.getItem("auth_id");
    const response = await fetchNodeData(
      setLoading,
      `tender/getTenders/${user_id}/${verticalActiveTab}`,
      secureLocalStorage.getItem("auth_token")
    );
    if (response?.status === 200) {
      const dataWithMappedField = response.data.map((item) => ({
        ...item,
        aboutTender: item.description,
      }));
      setTenderData(dataWithMappedField);
      setOriginalData2(dataWithMappedField);
    } else {
      setTenderData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [verticalActiveTab]);

  const onDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this Tender!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, do it!",
      cancelButtonText: "No, cancel!",
    }).then(async (willDelete) => {
      if (willDelete) {
        setLoading(true);
        const user_id = localStorage.getItem("auth_id");
        try {
          const response = await axios.delete(
            `${configure.nodeApi}/tender/${id}/${user_id}`
          );
          if (response.data.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Tender Deleted successfully",
            });
            fetchData();
          } else {
            Swal.fire({
              icon: "error",
              title: "error",
              text: response.data.message,
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "error",
            text: error.message,
          });
        }
      }
    });
  };

  const columns = useMemo(() => TenderColumns(onDelete), []);

  return (
    <>
      <div>
        {isLoading && <Loader />}
        <Row className="ms-0 pe-0">
          <Col lg={12} className="p-0" style={{ minHeight: "500px" }}>
            <Card>
              <CardBody>
                <TableContainer
                  columns={columns}
                  refreshData={fetchData}
                  data={tenderData}
                  setData={setTenderData}
                  status_options={TenderStatus}
                  setLoading={setLoading}
                  sourceId={verticalActiveTab}
                  originalData2={originalData2}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Tender;

